<template lang="pug">
  v-app(dark)
    v-navigation-drawer(v-model="drawer" app right dark)
    VueDragger
      v-layout(column align-center wrap)
        v-layout(row)
          v-sheet
            v-btn-toggle(v-model="toogleBtn")
              v-tooltip(bottom)
                template(v-slot:activator="{on}")
                  v-btn(depressed round v-on="on" to="/exam" dark outline)
                    v-icon home
                span Home
              //v-tooltip(bottom)
                template(v-slot:activator="{on}")
                  v-btn(depressed round v-on="on" @click.stop="drawer = !drawer" dark outline)
                    v-icon people
                span People
              v-tooltip(bottom)
                template(v-slot:activator="{on}")
                  v-btn(depressed round v-on="on" dark outline v-model="VE.display" @click="VE.display = !VE.display")
                    v-icon launch
                span Toogle VE
              v-icon(class="mx-2") drag_indicator
        v-layout(row class="mr-2")
          v-tooltip(bottom)
            template(v-slot:activator="{on}")
              VueCountdown(:time="3600000" emit-events @end="finish = true")
                div(class="my-2 mr-4" slot-scope="props" v-on="on") {{ props.hours }} : {{ props.minutes }} : {{props.seconds}}
            span Duration
    v-content
      LiveVE(:id="'izzatzr/' + $route.params.id" :display="VE.display") 
      v-snackbar(v-model="finish" top multi-line :timeout=0)
        h3(style="color: yellow") Please Proceed To The Next Step 
        v-btn(@click="finish = false" depressed dark color="yellow") Close
</template>
  
<script>
import LiveVE from '@/components/LiveVE.vue'
import VueCountdown from '@chenfengyuan/vue-countdown';
import VueDragger from 'vuedragger'
export default {
  components: {
    LiveVE,
    VueCountdown,
    VueDragger,
  },
  mounted() {
  },
  data: () => ({
    toogleBtn: 1,
    finish: null,
    drawer: null,
    VE: {
      display: true,
    }
  }),
  methods: {
  }
}
</script>
